import { Directive, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { MAT_DATE_RANGE_SELECTION_STRATEGY } from '@angular/material/datepicker';
import { MaxRangeSelectionStrategy } from './max-range-selection-strategy';
import { AbsenceLimitCalcTypeEnum } from 'src/app/models/enums/absence-limit-calc-type-enum';

@Directive({
  selector: '[maxRange]',
  providers: [
    {
      provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
      useClass: MaxRangeSelectionStrategy,
    },
  ],
  standalone: false
})
export class MaxRangeDirective implements OnChanges {
  private maxRangeStrategy = inject<MaxRangeSelectionStrategy<any>>(MAT_DATE_RANGE_SELECTION_STRATEGY);

  constructor() { }

  @Input() areWeekendsDaysOff: boolean;
  @Input() daysOff: Date[];
  @Input() absenceLimitCalcType: AbsenceLimitCalcTypeEnum;
  @Input() maxRange: number;

  ngOnChanges(changes: SimpleChanges): void {
    this.maxRangeStrategy.delta = Math.max(+this.maxRange || 0, 0);
    this.maxRangeStrategy.areWeekendsDaysOff = this.areWeekendsDaysOff;
    this.maxRangeStrategy.daysOff = this.daysOff;
    this.maxRangeStrategy.absenceLimitCalcType = this.absenceLimitCalcType;
  }
}
